var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{staticClass:"my-table",attrs:{"columns":_vm.table.columns,"data-source":_vm.table.data,"scroll":{ x: 1000 },"pagination":false,"bordered":""}})}
var staticRenderFns = []

export { render, staticRenderFns }